import React from "react";
import PropTypes from "prop-types";
import "./FilterChip.css";

const FilterChip = ({ label, onClose }) => {
  return (
    <div className="filter-chip">
      {label}
      <span className="chip-close" onClick={onClose}>
        ×
      </span>
    </div>
  );
};

FilterChip.propTypes = {
  label: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FilterChip;
